import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { BehaviorSubject, combineLatest } from "rxjs";

/**
 * This type takes an object and maps all of its keys to RxJS `BehaviorSubject`s and appends a $
 * to the property names to indicate that they are a subscription
 */

/**
 * Convert a state object to an object with rxjs `BehaviorSubject`s with "$" appended to each key name
 * @param state state object representing the state of a state service
 */
export var subjectify = state => {
  var entries = Object.entries(state);
  var mappedEntries = entries.map(_ref => {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    return ["".concat(key, "$"), new BehaviorSubject(value)];
  });
  return Object.fromEntries(mappedEntries);
};

/**
 * Takes an object with string keys mapped to rxjs `BehaviorSubject`s and makes a combined observable
 * that offers a subscription to an entire state object. The subscription will offer state updates with the
 * "$" removed from the end of every key in the subjects object. This is meant to be used with the output of `subjectify`
 * @param subjects object representing a group of rxjs `BehaviorSubject`s, keys should have a "$" at the end of
 * the name like the output of `subjectify`
 */
export var combineSubjects = subjects => {
  var entries = Object.entries(subjects);
  var mappedEntries = entries.map(_ref3 => {
    var _ref4 = _slicedToArray(_ref3, 2),
      key = _ref4[0],
      value = _ref4[1];
    return [key.slice(0, -1), value];
  });
  var subjectsWithNormalizedNames = Object.fromEntries(mappedEntries);
  return combineLatest(subjectsWithNormalizedNames);
};
//# sourceMappingURL=rxjsUtils.js.map